import { render, staticRenderFns } from "./B2B2C.vue?vue&type=template&id=8a036cb0&scoped=true"
import script from "./B2B2C.vue?vue&type=script&lang=js"
export * from "./B2B2C.vue?vue&type=script&lang=js"
import style0 from "./B2B2C.vue?vue&type=style&index=0&id=8a036cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a036cb0",
  null
  
)

export default component.exports